module.exports = __webpack_public_path__ + "static/img/link1.add2b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/link1.png
// module id = IdgG
// module chunks = 1